export enum NotificationType {
    UpdateEvent = 'update-event',
    UpdateInvitation = 'invitation-response-update',
    UpdateInvitationDetails = 'invitation-details-updated',
    UpdateInvitationResponseDetails = 'response-details-updated',
    UpdateInvitationApprovalStatus = 'approval-status-update',
    NewEvent = 'new-event',
    RestoreEvent = 'event-restored',
    CompletedEvent = 'completed-event',
    General = 'general',
    Hired = 'hired',
    CancelledEvent = 'event-cancelled',
    NewQuote = 'new-quote',
    DiscountUpdated = 'discount-updated',
    DiscountRemove = 'discount-remove',
    UpdatedQuote = 'updated-quote',
    Withdrawl = 'withdrawl',
    NewMessage = 'chat-message',
    ChatStarted = 'chat-started',
    NewConversation = 'new-conversation',
    DeleteQuote = 'deleted-quote'
} 
